import { FormikValues } from 'formik';

import { IChangelogV3 } from './changelog';

export type LPAccountsChangelog = {
  changelog: IChangelogV3;
};

export type SortableFields = 'created_at';

export type LPAccountChangelogFormValues = FormikValues & {
  lpaccount_id?: string;
  lpaccount_email?: string;
  created_by_id?: string;
  created_at_from?: string;
  created_at_to?: string;
};

export const initialFilters: LPAccountChangelogFormValues = {
  lpaccount_email: '',
  lpaccount_id: '',
  created_by_id: '',
  created_at_from: '',
  created_at_to: '',
};
